import { network } from 'services/network';

export const downloadXerFile = (params) => {
    const url = `api/bo/downloadXerFile/${params.id}`;
    return network
        .get(url, {
            responseType: 'blob',
        })
        .then((response) => {
            const blob = new Blob([response.data]);
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = params.fileName;
            a.click();
        });
};
